import React from 'react';
import ReactDOM from 'react-dom';

import Button from 'react-bootstrap/Button';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Jumbotron from 'react-bootstrap/Jumbotron';

import PopupBox from '../PopupBox.js';

import Countdown from '../Countdown.js';

export default class ColorCode extends React.Component {
  render() {


    //handle the click on one of the buttons
    const handleClick = (e) => {

      //if the id value of the button and compare to the correct answer
      if( parseInt(e.target.getAttribute("value")) == this.props.correct_answer)
      { 
        this.props.setResult(true, this)
      }
      else
      {
        this.props.setResult(false, this)
      }
    };


    const makeQuestion = () => {

        var question_letters = this.props.question.split('');

        var letters0 = this.props.text0.split('');

        var letters1 = this.props.text1.split('');

        var output = [];

        var letters0_counter = 0;
        var letters1_counter = 0;

        for(var i = 0; i < question_letters.length; i ++)
        {
            if(question_letters[i] == letters0[letters0_counter])
            {
                //this question letter the next one we need from letters0

                output.push(<span className={"colorcodebold colorcode text-"+this.props.color0}>{question_letters[i]}</span>)

                letters0_counter ++

            }
            else if(question_letters[i] == letters1[letters1_counter])
            {
                //this question letter the next one we need from letters1

                output.push(<span className={"colorcodebold colorcode text-"+this.props.color1}>{question_letters[i]}</span>)

                letters1_counter++
            }
            else
            {
                //letter not needed

                output.push(<span className={"colorcode text-primary"}>{question_letters[i]}</span>)
            }
        }



          // the div with children inside
          return (
            <div>
              {output}
            </div>
          );



        return output
    };

    return (

      <PopupBox position={this.props.position} getPos={this.props.getPos} question={this}>


      <Countdown time_allowed={300} getPos={this.props.getPos} question={this} setResult={this.props.setResult}></Countdown>

     
        <h3>{makeQuestion()}</h3>
        
        <br></br>

        <div className="d-flex justify-content-center">
          <ButtonToolbar>
            <Button value="0" onMouseDown={handleClick} className="mr-3" variant={this.props.color0} size="lg">-</Button>  
            <Button value="1" onMouseDown={handleClick} className="mr-3" variant={this.props.color1} size="lg">-</Button>
          </ButtonToolbar>
        </div>

      </PopupBox>

    );
  }
}
